// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Wrapper1{position:absolute;top:0;left:0;color:white;padding:10px;z-index:100;max-height:100%}.DebugSection{margin-bottom:10px}.DebugItem{color:white;font-family:monospace;margin:0;padding:0}\n", ""]);
// Exports
module.exports = exports;
